import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Showcase from '../components/Showcase/Showcase';
import About from '../components/About/About';
import Services from '../components/Services/Services';
import Herocase from '../components/Herocase/Herocase';
import Choose from '../components/Choose/Choose';
import Contact from '../components/Contact/Contact';
import Footer from '../components/Footer/Footer';
const Home = () => {
    return (
        <>
            <Navbar />
            <Showcase />
            <About />
            <Services />
            <Herocase />
            <Choose />
            <Contact />
            <Footer />
        </>
    )
}

export default Home
